import { Link } from 'react-router-dom'
import shelfMedia from '@/assets/handicrafts-novels-shelf.png'
import cafeShelfMedia from '@/assets/indian-cafe-shelf.png'
import { useSiteContent } from '@/hooks/useSiteContent'

const HomePage = () => {
  const { content } = useSiteContent()
  const heroImage = content.media.heroImageUrl || shelfMedia
  const shelfOwnerImage = content.media.shelfOwnerImageUrl || cafeShelfMedia
  const brandImage =
    content.media.brandImageUrl ||
    'https://images.unsplash.com/photo-1604719312566-8912e9227c6a?auto=format&fit=crop&w=1200&q=80'
  const partnerPaths = [
    {
      ...content.partners.realEstate,
      href: '/real-estate',
      image: shelfOwnerImage,
    },
    {
      ...content.partners.brands,
      href: '/brands',
      image: brandImage,
    },
  ]

  return (
    <main className="site-shell">
      <header className="site-nav">
        <Link to="/" className="brand-mark">{content.nav.brand}</Link>
        <nav aria-label="Primary navigation">
          <Link to="/real-estate" className="nav-cta">{content.nav.shelfOwnersCta}</Link>
          <Link to="/brands" className="nav-cta">{content.nav.brandsCta}</Link>
        </nav>
      </header>

      <section className="hero-section">
        <div className="hero-copy">
          <p className="eyebrow">{content.hero.eyebrow}</p>
          <h1>{content.hero.title}</h1>
          <p>{content.hero.body}</p>
        </div>
        <div className="hero-media" aria-label="Retail shelf media example">
          <img
            src={heroImage}
            alt="Curated shelf with handcrafted objects and novels"
          />
          <div className="media-note">
            <span>{content.hero.noteEyebrow}</span>
            <strong>{content.hero.noteTitle}</strong>
          </div>
        </div>
      </section>

      <section className="metric-strip" aria-label="Network highlights">
        {content.metrics.map((metric) => (
          <div key={metric.title}>
            <strong>{metric.title}</strong>
            <span>{metric.body}</span>
          </div>
        ))}
      </section>

      <section id="partners" className="section-block">
        <div className="section-heading">
          <p className="eyebrow">{content.partners.eyebrow}</p>
          <h2>{content.partners.title}</h2>
        </div>
        <div className="partner-grid">
          {partnerPaths.map((path) => (
            <Link to={path.href} className="partner-card" key={path.label}>
              <img src={path.image} alt={path.title} />
              <div>
                <p>{path.label}</p>
                <h3>{path.title}</h3>
                <span>{path.body}</span>
              </div>
            </Link>
          ))}
        </div>
      </section>

      <footer className="site-footer">
        <div className="footer-about">
          <p className="eyebrow">{content.footer.eyebrow}</p>
          <h2>{content.footer.title}</h2>
          <p>{content.footer.body}</p>
        </div>
        <div className="footer-contact">
          <p className="eyebrow">{content.footer.contactEyebrow}</p>
          <a href={`mailto:${content.footer.email}`}>{content.footer.email}</a>
        </div>
      </footer>
    </main>
  )
}

export default HomePage
